var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33956 18.3817L25.6056 1.47792L48.8717 18.3817L39.9849 45.7326H11.2264L2.33956 18.3817Z",
    stroke: "#3D8ECC",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.625 18.4375C13.625 17.9888 13.9888 17.625 14.4375 17.625H35.5625C36.0112 17.625 36.375 17.9888 36.375 18.4375V32.25C36.375 32.6987 36.0112 33.0625 35.5625 33.0625H14.4375C13.9888 33.0625 13.625 32.6987 13.625 32.25V18.4375ZM15.25 19.25V31.4375H34.75V19.25H15.25Z",
    fill: "#555555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 31.4375C25.2717 31.4375 25.5254 31.5733 25.676 31.7993L30.551 39.1118C30.8 39.4852 30.6991 39.9896 30.3257 40.2385C29.9523 40.4875 29.4479 40.3866 29.199 40.0132L25 33.7148L20.801 40.0132C20.5521 40.3866 20.0477 40.4875 19.6743 40.2385C19.3009 39.9896 19.2001 39.4852 19.449 39.1118L24.324 31.7993C24.4747 31.5733 24.7283 31.4375 25 31.4375Z",
    fill: "#555555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.875 21.6875C16.875 21.2388 17.2388 20.875 17.6875 20.875H22.5625C23.0112 20.875 23.375 21.2388 23.375 21.6875C23.375 22.1362 23.0112 22.5 22.5625 22.5H17.6875C17.2388 22.5 16.875 22.1362 16.875 21.6875ZM16.875 24.9375C16.875 24.4888 17.2388 24.125 17.6875 24.125H22.5625C23.0112 24.125 23.375 24.4888 23.375 24.9375C23.375 25.3862 23.0112 25.75 22.5625 25.75H17.6875C17.2388 25.75 16.875 25.3862 16.875 24.9375ZM16.875 28.1875C16.875 27.7388 17.2388 27.375 17.6875 27.375H22.5625C23.0112 27.375 23.375 27.7388 23.375 28.1875C23.375 28.6362 23.0112 29 22.5625 29H17.6875C17.2388 29 16.875 28.6362 16.875 28.1875Z",
    fill: "#555555"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0625 22.5C27.7163 22.5 26.625 23.5913 26.625 24.9375C26.625 26.2837 27.7163 27.375 29.0625 27.375C30.4087 27.375 31.5 26.2837 31.5 24.9375C31.5 23.5913 30.4087 22.5 29.0625 22.5ZM25 24.9375C25 22.6938 26.8188 20.875 29.0625 20.875C31.3062 20.875 33.125 22.6938 33.125 24.9375C33.125 27.1812 31.3062 29 29.0625 29C26.8188 29 25 27.1812 25 24.9375Z",
    fill: "#3D8ECC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaSupport);
export default __webpack_public_path__ + "static/media/media-support.34386cec9aec809adfcac9a2e9f074c6.svg";
export { ForwardRef as ReactComponent };